<template>
  <div v-show="showAnnotationControls" id="annotationControls" :style="getStyle">
    <span v-if="type === 'textarea'" >{{ fontSize }}px</span>
    <button v-if="type === 'textarea'" @click="increaseFontSize"><i class="fas fa-plus"></i></button>
    <button v-if="type === 'textarea'" @click="decreaseFontSize"><i class="fas fa-minus"></i></button>
    <button v-if="type === 'textarea'" @click="toggleEdit"><i :class="['fa', readOnly ? 'fa-pencil' : 'fa-save']"></i></button>
    <button @click="resize" alt="Resize"><i class="fas fa-expand"></i></button>
    <button @click="move" alt="Move"><i class="fas fa-arrows"></i></button>
    <button @click="rotate" alt="Rotate"><i class="fas fa-refresh"></i></button>
    <button @click="remove" alt="Remove"><i class="fas fa-times"></i></button>
  </div>
</template>

<script>
export default {
  name: 'annotation-controls',

  data () {
    return {
      showAnnotationControls: false,
      fontSize: 10,
      index: -1,
      x: 0,
      y: 0,
      type: 'textarea',
      readOnly: true
    }
  },

  mounted () {
    let that = this
    this.$bus.$on('pageChange', function () {
      that.showAnnotationControls = false
    })

    this.$bus.$on('hideControls', function () {
      that.showAnnotationControls = false
    })

    const elPos = this.$el.getBoundingClientRect()
    this.$bus.emit('showAnnotationControls', {
      index: this.index,
      type: 'image',
      x: elPos.left,
      y: elPos.top + elPos.height
    })

    this.$bus.$on('showAnnotationControls', function (data) {
      if (that.$store.state.drawingAnnotation) return
      if (data.index === that.index) {
        if (data.type === 'textarea') {
          let readOnly = document.getElementById('annotationTextarea-' + data.index).getAttribute('readonly')
          if (readOnly === null) return
        }
        that.x = data.x + window.pageXOffset
        that.y = data.y + window.pageYOffset
        that.showAnnotationControls = !that.showAnnotationControls
      } else {
        that.readOnly = true
        that.$bus.emit('setReadOnly', {
          index: that.index,
          value: that.readOnly
        })

        that.type = data.type
        that.showAnnotationControls = true
        that.index = data.index
        that.fontSize = typeof data.fontSize !== 'undefined' ? data.fontSize : 10
        that.x = data.x + window.pageXOffset
        that.y = data.y + window.pageYOffset
      }
    })
  },

  methods: {
    toggleEdit () {
      this.readOnly = !this.readOnly
      this.$bus.emit('setReadOnly', {
        index: this.index,
        value: this.readOnly
      })
    },

    increaseFontSize () {
      this.fontSize++
      this.$bus.emit('setFontSize', {
        index: this.index,
        size: this.fontSize
      })
      // this.$store.dispatch('saveAll')
    },

    decreaseFontSize () {
      if (this.fontSize - 1 <= 0) return
      this.fontSize--
      this.$bus.emit('setFontSize', {
        index: this.index,
        size: this.fontSize
      })
      // this.$store.dispatch('saveAll')
    },

    resize () {
      this.$bus.emit('resizeAnnotation', this.index)
    },

    move () {
      this.$bus.emit('moveAnnotation', this.index)
    },

    remove () {
      this.$bus.$emit('removeAnnotation', this.index)
    },

    rotate () {
      this.$bus.$emit('rotateAnnotation', this.index)
    }
  },

  computed: {
    getStyle: function () {
      return 'top:' + this.y + 'px;left:' + this.x + 'px;'
    }
  }
}
</script>

<style lang="scss" scoped>
  #annotationControls {
    background-color: #2D5F8B;
    cursor: default;
    z-index: 25;
    user-select: none;
    pointer-events: initial;

    position: absolute;
    top: 0;
    left: 0;
    padding: 5px;
    border: 1px solid black;
    border-radius: 5px;

    span {
      cursor: default;
      text-align: center;
      min-width: 40px;
      display: inline-block;
      color: white;
    }

    button {
      border-radius: 8px;
      border-style: hidden;
      padding-left: 10px;
      padding-right: 10px;

      border-style: hidden;
      transition: .3s;
      &:hover {
        background-color: #333;
        color: white;
        transition: .3s;
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/annotations/AnnotationControls.vue